import { wowpressMachineInternal } from './machine';
/**
 * 서비스 구현체를 주입받아 상태 머신 생성 로직을 반환하는 팩토리 함수.
 * @param fileService 파일 관련 서비스 구현체
 * @param authService 인증 관련 서비스 구현체
 * @param chatService 채팅 관련 서비스 구현체
 * @returns 생성된 XState setup 객체
 */
export function createWowpressMachineFactory(fileService, authService, chatService) {
    // wowpressMachineInternal 함수를 호출하여 그 결과를 반환
    return wowpressMachineInternal(fileService, authService, chatService);
}
// Re-exporting types is not necessary here as they are imported from './index' or 'xstate'
